import { Article } from 'interfaces/homepage';
import React from 'react';

import TimeAgo from '@components/TimeAgo';
import useEventTracking from '@hooks/useEventTracking';
import { article_path } from '@routes';
import { ClickTarget, ContentType, TrackingLocation, click } from '@tracking';

import { SectionTitle } from './SectionTitle';

interface RecommendedArticlesProps {
  recommendedArticles: Article[];
}

const RecommendedArticles = ({ recommendedArticles }: RecommendedArticlesProps) => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.RecommendedArticles,
  });

  return (
    <Track>
      <div className="mb-80 lg:mb-90">
        <SectionTitle title="Recommended" />
        {recommendedArticles.map((article, index) => (
          <div key={`${article.title}-${index}`} className="mb-32">
            <h2
              className="mb-3 mt-0 font-suisse-neue text-body-md text-primary-black"
              data-testid="recommended-article-title"
            >
              <a
                href={article_path(article.slug)}
                onClickCapture={() =>
                  trackEvent(
                    click({
                      contentType: ContentType.Article,
                      contentId: article.id,
                      contentIndex: index,
                      clickTarget: ClickTarget.RecommendedArticle,
                      clickText: article.title,
                      creatorIds: article.authors.map((author) => author.id),
                    })
                  )
                }
                className="text-inherit hover:text-primary-magenta"
              >
                {article.title}
              </a>
            </h2>
            <TimeAgo className="inline-block text-grayscale-gray" date={article.publishedAt} />
          </div>
        ))}
      </div>
    </Track>
  );
};

export default RecommendedArticles;
